// Provider Configuration
// This file contains provider filtering rules for specific locations

/**
 * Homepsych Location Provider Restrictions
 * 
 * As per request from Scott and Homepsych, only the following providers are allowed to show up for the homepsych location (facility ID 212)
 * in both the "Find Next Available Appointment" and "Choose Your Own Appointment" features.
 * 
 * Last updated: January 19, 2026
 */
export const HOMEPSYCH_ALLOWED_PROVIDERS = [
  'Branum, Faye, PA-C',
  'Michaels, Samuel, PA',
  'Smenkowski, Stephen, PA',
  'Milton, Derrick Xabien, PA-C'
];

/**
 * Facility ID for the Homepsych location
 */
export const HOMEPSYCH_FACILITY_ID = 212;

/**
 * Helper function to check if a provider is allowed for the homepsych location
 * @param {string} providerName - The full name of the provider (e.g., "Branum, Faye, PA-C")
 * @returns {boolean} - True if the provider is allowed for homepsych, false otherwise
 */
export const isAllowedHomepsychProvider = (providerName) => {
  return HOMEPSYCH_ALLOWED_PROVIDERS.includes(providerName);
};
